import { JobPosition } from '@restworld/utility-types';
import { formatJobPositionSalary, salaryLabelsFromT } from '@restworld/utils-common';

/**
 * Thin adapter over the centralized `formatJobPositionSalary`. All salary
 * formatting logic lives in `@restworld/utils-common` so the detail page, the
 * map popup and the explorer cards stay in sync. Returns '' (instead of null)
 * for the no-salary case to preserve the existing string-typed call sites.
 *
 * Pass `t` from `useTranslation('common')` so the salary words are localized.
 */
export const getSalary = ({
  jobPositionApiData,
  t,
}: {
  jobPositionApiData: Partial<JobPosition>;
  t: (key: string) => string;
}): string => formatJobPositionSalary(jobPositionApiData, salaryLabelsFromT(t)) ?? '';
